"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteSequence = void 0;
const regex_1 = require("../../../common/regex");
const NoteFactory_1 = require("../../note/NoteFactory");
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Defines a sequence of notes, optionally ended with a measure character.
 *
 * ### Notes
 *
 * - `0` - Blank, no note.
 * - `1` - Don.
 * - `2` - Ka.
 * - `3` - DON (big).
 * - `4` - KA (big).
 * - `5` - Drumroll. Must end with `8`.
 * - `6` - DRUMROLL (big). Must end with `8`.
 * - `7` - Balloon. Must end with `8`.
 * - `8` - End of drumroll or balloon.
 * - `9` - Kusudama, yam, oimo, or big balloon. Should end with an `8`. Use
 * another `9` to specify when to lower the points for clearing.
 * - `A` - DON (Both). Multiplayer note with hands.
 * - `B` - KA (Both). Multiplayer note with hands.
 * - `F` - ADLIB. Hidden note that will increase combo if discovered and does
 * not give a BAD when missed.
 *
 * **Example:**
 *
 * ```
 * 1020112010201120,
 * 34040122,
 * 1101103070000080,
 * 50080060,
 * 08009009,
 * ```
 *
 * ### Measures
 *
 * Measures in the chart are separated with a comma character `,` followed by a
 * line break. Timing between each measure is the same as long as `#MEASURE` and
 * `#BPMCHANGE` commands are not used. Measures may contain any amount of notes,
 * including zero, the less numbers there are in a measure, the more far apart
 * the notes will be in the chart, each measure is equally divided by the amount
 * of numbers there are inside. `12,` can be written as `1020,` and `10002000,`,
 * the timing is identical in all three examples.
 */
class NoteSequence extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.NoteSequence);
        this.notes = [];
    }
    addNote(note) {
        this.notes.push(note);
    }
    static parse(args, strict = true) {
        const command = new NoteSequence();
        const rawNotes = args.join('').replace(regex_1.SPACE_REGEX, '').split('');
        rawNotes.forEach((rawNote) => {
            const note = NoteFactory_1.NoteFactory.fromCourseValue(rawNote, strict);
            if (note) {
                command.addNote(note);
            }
        });
        return command;
    }
    toString() {
        return this.notes.join('');
    }
}
exports.NoteSequence = NoteSequence;
